<script setup>
import Modal from "@/components/modal/Modal.vue";
import {ref, useTemplateRef, watch} from "vue";

const SCANNER_THRESHOLD = 50; // milliseconds between inputs

const emit = defineEmits(['close', 'commitValue']);

const value = ref('');
let inputStartTimestamp = null;
let commitTimeout = null;

watch(value, (newValue) => {
    if (!newValue) {
        return;
    }

    if (inputStartTimestamp === null) {
        inputStartTimestamp = (new Date()).getTime();
    }

    if (commitTimeout !== null) {
        clearTimeout(commitTimeout);
    }

    if (newValue.length < 3) {
        return;
    }
    const now = (new Date()).getTime();
    const diff = Math.max(now - inputStartTimestamp, 1);
    const msBetweenChars = diff / newValue.length;

    if (msBetweenChars <= SCANNER_THRESHOLD) {
        commitTimeout = setTimeout(() => {
            commitValue();
        }, 5 * SCANNER_THRESHOLD);
    }
});

function commitValue() {
    emit('commitValue', value.value);
    close();
}

// Auto-focus the input field
const barcodeInput = useTemplateRef('barcodeInput');

watch(barcodeInput, (newValue) => {
    if (newValue) {
        newValue.focus();
    }
});

function revertFocus() {
    setTimeout(() => {
        if (barcodeInput.value) {
            barcodeInput.value.focus();
        }
    }, 10);
}

function close() {
    emit('close');
}
</script>

<template>
    <Modal :title="pgettext('title', 'Scan barcode')" @close="close" :max-width="800">
        <p class="text-subtitle-1 text-center">
            {{ pgettext('message', 'Please use the barcode scanner.') }}
        </p>

        <v-text-field ref="barcodeInput"
                      class="barcode-scanner-modal__barcode-input mx-4"
                      v-model="value"
                      @keydown.enter.prevent="commitValue()"
                      @keydown.tab.prevent="commitValue()"
                      @blur="revertFocus"/>
    </Modal>
</template>

<style>
.barcode-scanner-modal__barcode-input .v-field {
    font-size: 24px;
    font-weight: bold;
}
</style>
